/**
 * Los dos estados que toda vista que pide datos tiene que saber mostrar.
 *
 * Estan aca para que ninguna pantalla resuelva a su manera "esta cargando" o
 * "se cayo la API", y para que el mensaje de error diga algo util en vez de
 * "Error 500".
 */
import type { ErrorApi } from '../../tipos/api';
import { Icono } from './Icono';

/**
 * `pagina` es para la vista entera que todavia no tiene nada: reserva el alto
 * de la pantalla para que el pie no se vea y luego salte hacia abajo cuando
 * llegan los datos (era un CLS de 0,8 en la portada de escritorio).
 */
export function Cargando({ que, pagina = false }: { que: string; pagina?: boolean }) {
  return (
    <p className={pagina ? 'cargando cargando-pagina' : 'cargando'} role="status">
      Cargando {que}…
    </p>
  );
}

export function AvisoError({ error }: { error: ErrorApi | null }) {
  return (
    <div className="vacio" role="alert">
      <span className="vacio-icono">
        <Icono nombre="alerta" />
      </span>
      <h2>No pudimos cargar esta página</h2>
      <p>{error?.mensaje ?? 'Revisa tu conexión e intenta de nuevo en unos minutos.'}</p>
    </div>
  );
}
